import React, {FunctionComponent, useMemo, Fragment, useEffect} from 'react';
import './PhotoRoutes.css';
import {IPathFinder} from '../../../types/IPathFinder';
import PhotoDistance from './PhotoDistance/PhotoDistance';
import PhotoRoutesItems from './PhotoRoutesItems/PhotoRoutesItems';
import Splash from '../../ui/Splash/index';
import {IQueryParams} from "../../../types/IQueryParams";
import ReverseRouteLink from "./ReverseRouteLink/ReverseRouteLink";
import {EQUAL_ROUTE_NODES} from "../../../store/constants";
import TranslatedText from '../../ui/TranslatedText/TranslatedText';
import UITranslations from '../../../store/uiTranslations';

interface IPhotoRoutes {
    pathFinder?: IPathFinder;
    translateText: (id: number) => string;
    queryParams: IQueryParams;
    loading?: boolean;
}

const PhotoRoutes:FunctionComponent<IPhotoRoutes> = ({pathFinder, translateText, queryParams, loading}) => {

    const photoDistance = pathFinder ?
        <PhotoDistance
            distance = {pathFinder.distance}
            time = {pathFinder.time}
            unit = {pathFinder.unit}
            translateText = {translateText}
         /> : null;

    if(!queryParams.nodeFrom || !queryParams.nodeTo)
        return null;

    const showSameNodes = queryParams.nodeFrom === queryParams.nodeTo;
    const showRoute = !showSameNodes && !!pathFinder;
    const showPathNotFound = !(loading || showSameNodes || showRoute);

    return (
        <section className="PathFinder panel panel-body">
            {showSameNodes && <div className="text-center">{translateText(EQUAL_ROUTE_NODES)}</div>}
            {showRoute && (
                <Fragment>
                    <div className="row">
                        {photoDistance}
                    </div>
                    <PhotoRoutesItems pathFinder={pathFinder!}/>
                    <div className="row">
                        <div className="col-xs-12 text-center">
                            <ReverseRouteLink queryParams={queryParams}/>
                        </div>
                    </div>
                </Fragment>
            )}
            {showPathNotFound && (
                <div className="text-center">
                    <TranslatedText source={UITranslations.PhotoRoutePage.PathNotFound} />
                </div>
            )}
            {loading ? <Splash additionalClass="splash-module"/> : null}
        </section>
    )
};

export default PhotoRoutes;
